// removed by extract-text-webpack-plugin
module.exports = {"Layout":"Layout__1jgdY","Header":"Header__2cFa0","Content":"Content__3aoQX","Inner":"Inner__33hnq","Footer":"Footer__3z3yP","currentUser":"currentUser__1WBq0"};